import React from 'react'
import PropTypes from 'prop-types'
import STYLE_CONSTANTS from '~/style/constants'

const CirclePlusIcon = ({ color }) => {
  return (
    <svg
      width="22px"
      height="22px"
      viewBox="0 0 22 22"
      version="1.1"
      // xmlns="http://www.w3.org/2000/svg"
      // xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="desktop"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="New-flow_02_multiple-tickets-(1)"
          transform="translate(-886.000000, -304.000000)"
          fillRule="nonzero"
        >
          <g id="Group-11" transform="translate(874.000000, 235.000000)">
            <g id="Group-6" transform="translate(0.000000, 55.000000)">
              <g id="Group-3" transform="translate(12.000000, 14.000000)">
                <circle id="Oval" fill={color} cx="11" cy="11" r="11" />
                <g
                  id="Group-10"
                  transform="translate(6.875000, 6.969697)"
                  stroke="#FFFFFF"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.4"
                >
                  <path d="M4.125,0 L4.125,8.36363636" id="Line-7" />
                  <path
                    d="M4.125,0.253246753 L4.125,8.11038961"
                    id="Line-7"
                    transform="translate(4.125000, 4.181818) rotate(-270.000000) translate(-4.125000, -4.181818) "
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

CirclePlusIcon.defaultProps = {
  color: STYLE_CONSTANTS.colors.text.buttonGray
}

CirclePlusIcon.propTypes = {
  color: PropTypes.string
}

export default CirclePlusIcon
